import { AuthenticationForm } from '@dtx-company/inter-app/src/components/Authentication/AuthenticationForm'
import { BackButton } from '../../BackButton/BackButton'
import { FC } from 'react'
import { Stack } from '@dtx-company/design-system/src'

export const AuthSection: FC<{ hideBackButton?: boolean }> = ({ hideBackButton }) => {
  return (
    <>
      {!hideBackButton && <BackButton />}
      <Stack
        sx={theme => ({
          pt: 2,
          maxWidth: {
            md: hideBackButton ? 'auto' : theme.spacing(136)
          },
          width: '100%'
        })}
      >
        <AuthenticationForm action="sign up" product="flowcode" />
      </Stack>
    </>
  )
}
